<template>
  <div>
    <!-- Popup Modal -->
    <pl-dialog
      size="lg"
      :title="'Edit Verbal Discussion'"
      @close="$emit('close', false)"
      :disableOutsideClick="true"
    >
      <div class="h-full w-full pb-6 min-h-1/5 overflow-y-auto">
        <div class="h-full flex flex-col">
          <header class="pb-3 px-6">
            <div class="w-full mb-3">
              <h6 class="mb-1 text-gray-700 font-medium"> Title <span class="text-red-500">*</span></h6>
              <input
                v-model="title" 
                placeholder="Enter a title for Verbal RoundTable" 
                class="bg-white focus-within:border-gray-400 border border-solid border-gray-200 rounded w-full py-2 px-3" 
              />
            </div>
          </header>
          <main class="overflow-y-auto flex flex-col space-y-4 overflow-x-hidden h-full px-6 relative">
            <div id="instructions">
              <h6 class="mb-2 text-gray-700 font-medium">Instructions</h6>
              <div class="bg-trueGray-100 rounded border focus-within:border-gray-400  border-solid border-gray-200" style="height:150px">
                <RichTextEditor 
                  id="text-editor-verbal"
                  v-model="instructions"
                  :init="editor_options"
                />
              </div>
            </div>
            <div>
              <div class="flex justify-between items-center mb-2">
                <h6 class="text-blueGray-700 font-medium">Content and Multimedia</h6>
              </div>
              <div class="relative bg-gray-100 overflow-y-auto rounded border border-solid border-gray-200 px-3 py-3" >
                <div class="flex justify-between items-center space-x-2" :class="[{'pb-3': resource_questions.length > 0 }]">
                  <input
                    placeholder="Enter a Resource Name"
                    class="bg-white focus-within:border-gray-400 w-full py-2 px-4 rounded border border-solid border-gray-200"
                    v-model="new_resource_name"
                  />
                  <input
                    placeholder="Enter a Resource URL"
                    @keyup.enter="createEditResource"
                    class="bg-white focus-within:border-gray-400 w-full py-2 px-4 rounded border border-solid border-gray-200"
                    v-model="new_resource_url"
                    
                  />
                  <button @click="createEditResource" class="bg-blueGray-700 text-white py-2 px-4 rounded">
                    Add
                  </button>
                </div>
                <Draggable 
                  v-model="resource_questions"
                  @start="drag_content_resource = true" 
                  @end="drag_content_resource = false" 
                  handle=".handle"
                  class="h-full flex-grow overflow-y-auto"
                >
                  <div v-for="(resource, index) in resource_questions" :key="index" class="flex flex-col space-y-2">
                    <ResourceOption 
                      :resource_url="resource.resourceURL"
                      :is_active="resource.is_active"
                      :resource_name="resource.resourceName"
                      @change_active_status="(id_option) => handleChangeResourceStatus(id_option)"
                      @delete_resource_content="(id_option) => handleRemoveContentMultimedia(id_option)"
                      @save_information_before_edit="(info) => handleEditResourceContent(info)"
                      :id="index" 
                      :key="index"
                      class="mb-1.5" 
                    />
                  </div>
                </Draggable>
              </div>
            </div>
            <div>
              <div class="flex justify-between items-center mb-2">
                <h6 class="text-blueGray-700 font-medium">Questions</h6>
              </div>
              <div class="relative bg-gray-100 overflow-y-auto rounded border border-solid border-gray-200 px-3 py-3" >
                <div class="flex justify-between items-center space-x-2" :class="[{'pb-3': guiding_questions.length > 0 }]">
                  <input
                    placeholder="Enter a Question"
                    @keyup.enter="addEditGuidingQuestion"
                    class="bg-white focus-within:border-gray-400 w-full py-2 px-4 rounded border border-solid border-gray-200"
                    v-model="new_guiding_question"
                  />
                  <button @click="addEditGuidingQuestion" class="bg-blueGray-700 text-white py-2 px-4 rounded">
                    Add
                  </button>
                </div>
                <Draggable 
                  v-model="guiding_questions" 
                  @start="drag_content_resource = true" 
                  @end="drag_content_resource = false"
                  handle=".handle" 
                  class="h-full flex-grow overflow-y-auto overflow-x-hidden"
                >
                  <div v-for="(element, index) in guiding_questions" :key="element.question">
                    <QuestionOption 
                      :is_active="element.is_active"
                      :is_custom="element.is_custom"
                      :question_name="element.question"
                      @change_active_status="(id_option) => handleChangeQuestiontatus(id_option)"
                      @delete_question="(id_option) => handleRemoveQuestion(id_option)"
                      @save_information_before_edit="(info) => handleEditQuestion(info)"
                      :id="index"
                      :key="index"
                      class="mb-1.5 w-full" 
                    />
                  </div>
                </Draggable>
              </div>
            </div>
          </main>
          <footer class="px-6 mt-3 flex justify-between">
            <button
              class="px-4 py-2 rounded cursor-pointer text-gray-700 border border-solid border-gray-200"
              @click="$emit('close', false)"
            >
              Cancel
            </button>
            <button
              class="sample px-5 py-2 bg-primary rounded cursor-pointer text-white font-medium"
              @click="saveLiveRt"
            >
              Save Changes
            </button>
          </footer>
        </div>
      </div>
    </pl-dialog>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex';
  import { EventBus } from 'utils/event-bus';
  import { EditorOptionsVerbal } from './New_RoundTable/EditorMCE/EditorConfig';

  export default {
    components: {
      RichTextEditor: () => import('@tinymce/tinymce-vue'),
      Draggable: () => import('vuedraggable'),
      ResourceOption: () => import('./New_RoundTable/Pages/Discussions/Verbal/Components/ResourceOption.vue'),
      QuestionOption: () => import('./New_RoundTable/Pages/Discussions/Verbal/Components/QuestionOption.vue'),
    },
    data() {
      return {
        title: '',
        instructions: '',
        resource_questions: [],
        guiding_questions: [],
        new_resource_url: '',
        new_resource_name: '',
        new_guiding_question: '',
        editing_guiding_question: false,
        editing_resource: false,
        editing_guiding_question_index: null,
        editing_resource_index: null,
        editor_options: EditorOptionsVerbal,
        drag_content_resource: false,
      };
    },
    props: {
      rt_selected: {
        type: Object,
        default() {
          return {};
        },
      },
    },
    computed: {
      ...mapGetters(['getCurrentDiscussion']),
    },
    methods: {
      handleChangeResourceStatus: function(id_option_resource) {
        const resource_object = this.resource_questions.find((obj, index) => index === id_option_resource);
        resource_object.is_active = !resource_object.is_active;
        return;
      },
      handleRemoveContentMultimedia: function(index_to_remove) {
        this.resource_questions.splice(index_to_remove, 1);
        return;
      },
      handleEditResourceContent: function(info){
        const resource = this.resource_questions.find((obj, index) => index === info.id);
        resource.resourceName = info.resource_name;
        resource.resourceUrl = info.resource_url;
        return;
      },
      handleChangeQuestiontatus: function(index_to_change) {
        const resource_object = this.guiding_questions.find((obj, index) => index === index_to_change);
        resource_object.is_active = !resource_object.is_active;
        return;
      },
      handleRemoveQuestion: function(index_to_remove) {
        this.guiding_questions.splice(index_to_remove, 1);
        return;
      },
      handleEditQuestion: function(info) {
        const resource = this.guiding_questions.find((obj, index) => index === info.id);
        resource.question = info.question_name;
        return;
      },
      validateUrl(value) {
        return /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(
          value
        );
      },
      createEditResource() {
        if (this.editing_resource) {
          this.saveEditResource();
        } else {
          this.createNewResource();
        }
      },
      createNewResource() {
        const valid_url = this.validateUrl(this.new_resource_url);
        if (!valid_url || !this.new_resource_name) {
          const toast = {
            type: 'Error',
            message: 'Invalid URL or Resource Name is empty.',
            time: 5000,
          };
          EventBus.$emit('createToast', toast);
          return;
        } else {
          this.resource_questions.push({
            resourceName: this.new_resource_name,
            resourceURL: this.new_resource_url,
            is_active: true,
          });
          const toast = {
            type: 'Success',
            message: 'New resource created with success',
            time: 5000,
          };
          EventBus.$emit('createToast', toast);
          this.new_resource_name = '';
          this.new_resource_url = '';
        }
      },
      openResourceLink(resource) {
        window.open(resource.resourceURL);
      },
      editResource(index, resource) {
        this.editing_resource = true;
        this.editing_resource_index = index;
        this.new_resource_name = resource.resourceName;
        this.new_resource_url = resource.resourceURL;
      },
      saveEditResource() {
        this.resource_questions[this.editing_resource_index] = {
          resourceName: this.new_resource_name,
          resourceURL: this.new_resource_url,
          is_active:
            this.resource_questions[this.editing_resource_index].is_active,
        };

        const valid_url = this.validateUrl(this.new_resource_url);
        if (!valid_url || !this.new_resource_name) {
          const toast = {
            type: 'Error',
            message: 'Invalid URL or Resource Name is empty.',
            time: 5000,
          };
          EventBus.$emit('createToast', toast);
          return;
        } else {
          this.new_resource_name = '';
          this.new_resource_url = '';
          this.error_message = '';
          this.editing_resource_index = null;
          this.editing_resource = false;
        }
      },
      deleteResource(index) {
        this.resource_questions.splice(index, 1);
      },
      addEditGuidingQuestion() {
        if (this.editing_guiding_question) {
          this.saveEditGuidanceQuestion();
        } else {
          this.createNewGuidingQuestion();
        }
      },
      createNewGuidingQuestion() {
        if (!this.new_guiding_question) return;
        this.guiding_questions.push({
          question: this.new_guiding_question,
          is_active: true,
          is_custom: true,
        });
        const toast = {
          type: 'Success',
          message: 'New guiding question created with success',
          time: 5000,
        };
        EventBus.$emit('createToast', toast);
        this.new_guiding_question = '';
      },
      editGuidanceQuestion(index, question) {
        this.editing_guiding_question = true;
        this.editing_guiding_question_index = index;
        this.new_guiding_question = question.question;
      },
      saveEditGuidanceQuestion() {
        this.guiding_questions[this.editing_guiding_question_index] = {
          question: this.new_guiding_question,
          is_active:
            this.guiding_questions[this.editing_guiding_question_index]
              .is_active,
          is_custom:
            this.guiding_questions[this.editing_guiding_question_index]
              .is_custom,
        };

        this.new_guiding_question = '';
        this.editing_guiding_question_index = null;
        this.editing_guiding_question = false;
      },
      deleteGuidanceQuestion(index) {
        this.guiding_questions.splice(index, 1);
      },
      saveLiveRt() {
        this.$store
          .dispatch('saveLiveDiscussionSettings', {
            id: this.rt_selected.id,
            title: this.title,
            instructions: this.instructions,
            toggleable_guiding_questions: this.guiding_questions,
            toggleable_resource_questions: this.resource_questions,
          })
          .then(() => {
            const toast = {
              type: 'Success',
              message: 'Verbal RoundTable edited with success',
              time: 5000,
            };
            EventBus.$emit('createToast', toast);
            this.$emit('close');
          })
          .catch((err) => {
            const toast = {
              type: 'Error',
              message: 'Something went wrong, please try again.',
              time: 5000,
            };
            EventBus.$emit('createToast', toast);
            this.$emit('close');
            console.error(err);
          });
      },
      up(index) {
        if (index === 0) {
          return;
        } else {
          this.resource_questions = this.resource_questions.map(
            (element, i) => {
              if (i === index - 1) {
                return this.resource_questions[index];
              } else if (i === index) {
                return this.resource_questions[index - 1];
              } else {
                return element;
              }
            }
          );
        }
      },

      down(index) {
        if (index === this.resource_questions.length - 1) {
          return;
        } else {
          this.resource_questions = this.resource_questions.map(
            (element, i) => {
              if (i === index) {
                return this.resource_questions[index + 1];
              } else if (i === index + 1) {
                return this.resource_questions[index];
              } else {
                return element;
              }
            }
          );
        }
      },
    },
    created() {
      this.title = this.rt_selected.title;
      this.instructions = this.rt_selected.instructions;
      const { toggleable_resource_questions } = this.rt_selected;
      this.resource_questions = JSON.parse(
        JSON.stringify(toggleable_resource_questions)
      );
      const { toggleable_guiding_questions } = this.rt_selected;
      this.guiding_questions = JSON.parse(
        JSON.stringify(toggleable_guiding_questions)
      );
    },
  };
</script>
<style scoped lang="scss"></style>



// WEBPACK FOOTER //
// editLiveRtModal.vue?0ecfd7ac